import React from 'react';
import { usePricingState } from '../state/pricing.state';
import { Button } from '../../button/Button';

interface IPricingModeSelector {}

export const PricingModeSelector: React.FC<IPricingModeSelector> = () => {
    const { mode, setMode } = usePricingState();

    return (
        <section className="relative mx-auto flex w-max flex-row gap-4 rounded-full pb-6">
            <Button
                onClick={() => setMode(false)}
                color={mode === 'monthly' ? 'primary' : 'neutral'}
            >
                Monthly
            </Button>
            <Button onClick={() => setMode(true)} color={mode === 'annual' ? 'primary' : 'neutral'}>
                Annual
            </Button>
        </section>
    );
};
